module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    产品续费\n  ")]), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin": "0 0.1rem",
      "border-radius": "0.3rem"
    },
    attrs: {
      "label-width": "5em"
    }
  }, [_c('popup-picker', {
    attrs: {
      "title": "续费时长",
      "data": _vm.list1,
      "columns": 1
    },
    on: {
      "on-hide": _vm.getPrice
    },
    model: {
      value: (_vm.xufeiForm.region),
      callback: function($$v) {
        _vm.$set(_vm.xufeiForm, "region", $$v)
      },
      expression: "xufeiForm.region"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "IP地址",
      "value": _vm.xufeiForm.ip
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "原到期时间",
      "value": _vm.xufeiForm.endtime
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "value": _vm.xufeiForm.newtime
    }
  }, [_c('span', {
    staticStyle: {
      "width": "8em",
      "display": "inline-block"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("续费后到期时间")])]), _vm._v(" "), _c('popup-picker', {
    attrs: {
      "title": "优惠券",
      "data": _vm.xufeiForm.yhq,
      "columns": 1
    },
    on: {
      "on-hide": _vm.getPrice
    },
    model: {
      value: (_vm.xufeiForm.coupon),
      callback: function($$v) {
        _vm.$set(_vm.xufeiForm, "coupon", $$v)
      },
      expression: "xufeiForm.coupon"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "余额"
    }
  }, [_c('span', {
    staticClass: "text-orange"
  }, [_vm._v(_vm._s(_vm.xufeiForm.money))])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "所需费用"
    }
  }, [_c('span', {
    staticClass: "text-orange"
  }, [_vm._v(_vm._s(_vm.xufeiForm.price))])])], 1), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": "1rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Renew($event)
      }
    }
  }, [_vm._v("确认")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01427fe4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/serverrenew.vue
// module id = MGVi
// module chunks = 1